// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendAstatDailyIstatClosureMutationVariables = Types.Exact<{
  sendAstatDailyIstatClosureRequestDTO: Types.SendAstatDailyIstatClosureRequestDtoInput;
}>;


export type SendAstatDailyIstatClosureMutationResult = { __typename?: 'Mutation', sendAstatDailyIstatClosure: string | null };

export const SendAstatDailyIstatClosureGql = gql`
    mutation SendAstatDailyIstatClosure($sendAstatDailyIstatClosureRequestDTO: SendAstatDailyIstatClosureRequestDTOInput!) {
  sendAstatDailyIstatClosure(
    sendAstatDailyIstatClosureRequestDTO: $sendAstatDailyIstatClosureRequestDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendAstatDailyIstatClosureInjectable extends Apollo.Mutation<SendAstatDailyIstatClosureMutationResult, SendAstatDailyIstatClosureMutationVariables> {
    override document = SendAstatDailyIstatClosureGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */